import { LoginCredentials, LoginResponse, UserProfile } from "./types";
import { API_ENDPOINTS } from "../../shared/api/endpoints";

import {
  authApiClient,
  onboardingApiClient,
} from "@shared/api/clients/apiClientFactory";
import { ApiEndpoints } from "@shared/api/api-endpoints";

// Add your feature-specific API calls here
export const authApi = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await authApiClient.post(API_ENDPOINTS.auth.login, {
      user: credentials,
    });
    return response.data;
  },

  forgotPassword: async (email: string): Promise<void> => {
    const response = await authApiClient.post(
      API_ENDPOINTS.auth.forgotPassword,
      {
        email: email,
      }
    );
    return response.data;
  },

  resetPassword: async (token: string, password: string): Promise<void> => {
    const response = await authApiClient.post(
      API_ENDPOINTS.auth.resetPassword,
      {
        token,
        password,
      }
    );
    return response.data;
  },

 getUserProfile: async (): Promise<UserProfile> => {
  const token = localStorage.getItem("auth_token");

  if (!token) {
    // Stop API call at the source
    return Promise.reject(new Error("No auth token present"));
  }

  const response = await authApiClient.get(API_ENDPOINTS.auth.profile);
  return response.data.result;
},

  logout: async (): Promise<void> => {
    const response = await authApiClient.post(API_ENDPOINTS.auth.logout, {});
    return response.data;
  },
};

export const forgotPassword = async (payload: {
  email: string;
}): Promise<any> => {
  const url = ApiEndpoints.createUrl("auth", "auth/forgot-password");
  const response = await authApiClient.post(url, payload);
  return response.data;
};

// api/auth.ts

export const resetPassword = async (
  payload: { password: string,email:any },
  queryParams: { et: string; code: string }
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "auth",
    "auth/reset-password",
    (query) => {
      query.push("et", queryParams.et);
      query.push("code", queryParams.code);
    }
  );

  const response = await authApiClient.post(url, payload);
  return response.data;
};
